import { render } from "./PpcStrategyShadowRow.vue?vue&type=template&id=5f7c2132&scoped=true"
import script from "./PpcStrategyShadowRow.vue?vue&type=script&lang=js"
export * from "./PpcStrategyShadowRow.vue?vue&type=script&lang=js"

import "./PpcStrategyShadowRow.vue?vue&type=style&index=0&id=5f7c2132&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7c2132"]])

export default __exports__